import React, { Component } from 'react';

//styles
import './topSection.scss';
import '../../static/fonts/Rubik/stylesheet.css'
import { scrollDown } from '../../static/scrollAnimation'

class TopSection extends Component {
    componentDidMount() {
        
    }

    render() {
        return (
            <div id="section1" className="section1-container">
                <div className="image"></div>
                <div className="desc-container">
                    <div className="title">העניים החדשים</div>
                    <div className="desc">שחיקתו של מעמד הביניים בישראל</div>
                    <div className="credit">עורכת: שלומית שרביט ברזילי</div>
                </div>
                <div className="down-arrow" onClick={() => scrollDown("section2-container", -70)}></div>
            <div className="line"></div>
            </div>
        );
    }
}

export default TopSection;


// WEBPACK FOOTER //
// ./src/Components/TopSection/TopSection.js